'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
require('./icons.scss');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint-disable */
var Fishing = function (_PureComponent) {
  (0, _inherits3.default)(Fishing, _PureComponent);
  function Fishing() {
    (0, _classCallCheck3.default)(this, Fishing);
    return (0, _possibleConstructorReturn3.default)(this, (Fishing.__proto__ || (0, _getPrototypeOf2.default)(Fishing)).apply(this, arguments));
  }
  (0, _createClass3.default)(Fishing, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['className']);
      return _react2.default.createElement('svg', (0, _extends3.default)({
        viewBox: '0 0 32 32',
        style: {
          width: '1em',
          height: '1em'
        },
        preserveAspectRatio: 'xMidYMid meet'
      }, otherProps, {
        className: (0, _classnames2.default)('sb-icon-svg', className),
        xmlns: 'http://www.w3.org/2000/svg'
      }), _react2.default.createElement('path', {
        d: 'M2.704 12.882c.16 1.75-1.07 3.148.098 6.926-.246-.038-.836-.134-1.048-.234-.648-.304-1.248-.93-1.248-.93.52 2.022 2.558 3.086 3.28 3.408.972 1.682 2.522 3.366 4.96 4.828 4.76 2.856 12.294 1.604 16.59-3.912a4.284 4.284 0 0 1 1.012.914c.07.084.146.164.212.254.086.116.164.244.246.368.06.094.124.184.182.282.076.13.146.268.218.406.052.1.106.198.156.302.068.142.128.286.19.432.044.104.09.208.132.314.058.148.112.298.164.448.038.108.076.214.112.322.05.15.096.3.14.452.032.108.064.216.092.322a18.14 18.14 0 0 1 .192.76 21.182 21.182 0 0 1 .156.728l.076.398a63.078 63.078 0 0 1 .106.642c.014.088.024.17.036.252a12.67 12.67 0 0 1 .068.524l.03.256.018.176.018.178c.006.058.008.1.012.14.002.028.006.066.006.086a.782.782 0 0 0 0 .076c.116-.392.206-.778.284-1.16.022-.104.04-.206.058-.308.054-.304.1-.604.132-.9.008-.078.02-.158.028-.236.036-.37.056-.734.062-1.09l-.002-.134a13.913 13.913 0 0 0-.042-1.158c-.024-.314-.056-.62-.1-.92-.004-.022-.004-.044-.008-.064-.048-.326-.108-.64-.174-.946-.014-.066-.03-.128-.044-.192a15.963 15.963 0 0 0-.176-.694l-.06-.216c-.078-.264-.16-.524-.248-.768-.018-.052-.038-.1-.058-.152a16.318 16.318 0 0 0-.332-.836c-.048-.11-.094-.216-.142-.32a14.7 14.7 0 0 0-.994-1.842c.28-.612.53-1.256.74-1.936 0 0 1.51-3.676 1.856-5.518.348-1.842 2.202-6.176 2.202-6.176l-.374.334c.04-.086.07-.144.07-.144L28.68 9.292S30.432 2.796 31.758 0c0 0-5.95 9.682-7.118 10.606-1.07.848-5.594 3.28-7.068 5.454-2.096 1.07-4.33 2.306-5.11 3.068l3.392.126c-1.482 2.202-3.924 4.354-7.152 2.574a7.88 7.88 0 0 1-.96-.63c-3.426-2.612-4.492-6.514-4.302-7.532.192-1.034 1.368-1.276 1.368-1.276 2.768.408 7.016-2.976 7.016-2.976s-4.016.768-7.01-.088C1.82 8.47.778 2.23.778 2.23c-2.034 3.828.476 8.758 1.256 9.178 0 0 .632 1.074.67 1.474zm23.072-1.238c.372-.456.934-.612 1.262-.344.328.27.294.856-.076 1.316-.37.458-.934.61-1.26.342-.326-.272-.292-.858.074-1.314z'
      }));
    }
  }]);
  return Fishing;
}(_react.PureComponent);
Fishing.propTypes = {
  className: _propTypes.PropTypes.string
};
exports.default = Fishing;